// extracted by mini-css-extract-plugin
export default {"containers":"modules_containers__K2TLw","inner":"modules_inner__znwmH","module_box":"modules_module_box__agB0Y"};